const parseEnv = (key: string) => {
  //@ts-ignore
  const env = process.browser ? window.__QUILLBOT_ENVS__?.[key] : process.env[key];

  //console.log('env', { [key]:env })
  return env;
};

const getConfig = () => ({
  publicRuntimeConfig: {
    QUILLBOT_ENV: parseEnv('PUBLIC__QUILLBOT_ENV'),
    APP_VERSION: parseEnv('PUBLIC__APP_VERSION'),
    KLAVIO_CLASSNAME: parseEnv('PUBLIC__KLAVIO_CLASSNAME'),
    STUDENT_RESOURCE_KLAVIO_CLASSNAME: parseEnv('PUBLIC__KLAVIO_STUDENT_RESOURCE_CLASSNAME'),
    KLAVIO_COMPANY_ID: parseEnv('PUBLIC__KLAVIO_COMPANY_ID'),
    FIREBASE_MEASUREMENT_ID: parseEnv('PUBLIC__FIREBASE_MEASUREMENT_ID'),
    FIREBASE_APP_ID: parseEnv('PUBLIC__FIREBASE_APP_ID'),
    FIREBASE_MESSAGING_SENDER_ID: parseEnv('PUBLIC__FIREBASE_MESSAGING_SENDER_ID'),
    FIREBASE_STORAGE_BUCKET: parseEnv('PUBLIC__FIREBASE_STORAGE_BUCKET'),
    FIREBASE_PROJECT_ID: parseEnv('PUBLIC__FIREBASE_PROJECT_ID'),
    FIREBASE_DATABASE_URL: parseEnv('PUBLIC__FIREBASE_DATABASE_URL'),
    FIREBASE_AUTH_DOMAIN: parseEnv('PUBLIC__FIREBASE_AUTH_DOMAIN'),
    FIREBASE_API_KEY: parseEnv('PUBLIC__FIREBASE_API_KEY'),
    MICROFRONTEND_CONFIG_URL: parseEnv('PUBLIC__MICROFRONTEND_CONFIG_URL'),
    QUILL_BACKEND_HOST: parseEnv('PUBLIC__QUILL_BACKEND_HOST'),
    QUILL_TRACKING_HOST: parseEnv('PUBLIC__QUILL_TRACKING_HOST'),
    AMPLITUDE_API_KEY: parseEnv('PUBLIC__AMPLITUDE_API_KEY'),
    BUGSNAG_API_KEY: parseEnv('PUBLIC__BUGSNAG_API_KEY'),
    GTAG_TRACKING_ID: parseEnv('PUBLIC__GTAG_TRACKING_ID'),
    GA_TRACKING_ID: parseEnv('PUBLIC__GA_TRACKING_ID'),
    STRIPE_API_KEY: parseEnv('PUBLIC__STRIPE_API_KEY'),
    CHARGEBEE_SITE: parseEnv('PUBLIC__CHARGEBEE_SITE'),
    CHARGEBEE_PUBLISHABLE_KEY: parseEnv('PUBLIC__CHARGEBEE_PUBLISHABLE_KEY'),
    CHROME_EXTENSION_ID: parseEnv('PUBLIC__CHROME_EXTENSION_ID'),
    CHROME_EXTENSION_URL: parseEnv('PUBLIC__CHROME_EXTENSION_URL'),
    GOOGLE_CLIENT_ID: parseEnv('PUBLIC__GOOGLE_CLIENT_ID'),
    PARTNERSTACK_PUBLIC_KEY: parseEnv('PUBLIC__PARTNERSTACK_PUBLIC_KEY'),
    ASSETS_URL: parseEnv('PUBLIC__ASSETS_URL'),
    LIB_BUCKET_URL: parseEnv('PUBLIC__LIB_BUCKET_URL'),
    DATADOG_CLIENT_TOKEN: parseEnv('PUBLIC__DATADOG_CLIENT_TOKEN'),
    DATADOG_APPLICATION_ID: parseEnv('PUBLIC__DATADOG_APPLICATION_ID'),
    DATADOG_SAMPLE_RATE: parseEnv('PUBLIC__DATADOG_SAMPLE_RATE'),
  },
  serverRuntimeConfig: {
    PRICING_API_URL: parseEnv('PRICING_API_URL'),
    REST_SERVER_DIRECT_URL: parseEnv('REST_SERVER_DIRECT_URL'),
  },
});

export default getConfig;

export { getConfig };
